import { $nocobaseProxy } from ".";
import type {
  SameDayCancellation,
  CreateSameDayCancellationData,
} from "@/@types/sameDayCancellation.types";

interface SameDayCancellationListResponse {
  data: SameDayCancellation[];
  meta: {
    count: number;
    page: number;
    pageSize: number;
    totalPage: number;
  };
}

interface SameDayCancellationResponse {
  data: SameDayCancellation;
}

export async function createSameDayCancellation(
  _phone: string,
  data: CreateSameDayCancellationData,
  clubId?: string
) {
  return $nocobaseProxy.post<SameDayCancellationResponse>("/same_day_cancellation:create", data, {
    headers: clubId ? { "X-Club-Id": clubId } : undefined,
  });
}

export async function cancelSameDayCancellation(_phone: string, id: number) {
  return $nocobaseProxy.post(`/same_day_cancellation:update?filterByTk=${id}`, {
    state: "cancelled_by_user",
  });
}

export async function getSameDayCancellations(
  _phone: string,
  params?: { page?: number; pageSize?: number }
) {
  const filter = JSON.stringify({
    state: { $ne: "cancelled_by_user" },
  });
  return $nocobaseProxy.get<SameDayCancellationListResponse>("/same_day_cancellation:list", {
    params: {
      page: params?.page || 1,
      pageSize: params?.pageSize || 100,
      filter,
    },
  });
}
